export const customStyles = {
  menuList: (styles) => ({
    ...styles,
    background: "white",
  }),
  singleValue : (styles)=>({
    ...styles,
    fontSize: '12px',
    textAlign: 'left',
    fontWeight:'600',
    color: 'black'
  }),
  placeholder : (styles)=>({
    ...styles,
    fontSize: '12px',
    textAlign: 'left',   
    fontWeight:'300',
    color: 'black',
    fontStyle:"italic"
  }),
  
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    // "&:hover": {
    //           backgroundColor: state.isSelected ? "#D9E9F3" : "#D9E9F3",
    //         },
    background: isSelected
      ? "hsla(351, 84%, 46%, 1)"
      : isFocused
      ? "#EAEAEA"
      : undefined,
    zIndex: 1,
    color: isSelected ? "white !important" : "black !important",
    fontWeight : 400,
    fontSize: 12,
    // color: 'black !important',
    cursor: "pointer",
  }),
  valueContainer: (base) => ({
    ...base,
    // minWidth: 172,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100,

    // height:"60px !important",
    border: "none",
  }),
  control: (base) => ({
    ...base,
    
    minHeight: 42,
    minWidth: 92,
    border: 0,
    // This line disable the blue border
    boxShadow: "none",
    height: 42,
    // border:"none",
    borderRadius: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#CE0E2D",
    "&:hover": {
      color: "#CE0E2D",
    },
  }),
  indicatorSeparator: (base) => ({
    ...base,
  display: "none",
  })
};
